module.exports = __webpack_public_path__ + "static/media/26pic.00e75128.jpg";